import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from '../constants/Breakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
export const PPUIPageHeader = styled.header.withConfig({
  displayName: "PageHeader__PPUIPageHeader",
  componentId: "sc-10lzf9a-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    inlineSize: '100%',
    marginBlockEnd: theme.space[800],
    [trellisBreakpoint.tablet]: {
      paddingInline: theme.space[300]
    }
  };
});
export const PageTitle = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Text, Object.assign({
    as: "h1",
    marginBlockEnd: "200",
    display: "inline-block"
  }, props, {
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      children: children
    })
  }));
};
export const PageSubTitle = props => {
  return /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
    as: "p"
  }));
};